import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaidarshanpackage() {



  const cardData = {


  keyword: "Pune to Mumbai Darshan Package",

  headingDescription: "Trustline Travels offers affordable Pune to Mumbai Darshan packages with comfortable chauffeur-driven vehicles for one-day sightseeing, family vacations, corporate outings, group tours, and weekend trips. Our customized Mumbai Darshan packages cover the city's most popular tourist attractions, religious places, heritage landmarks, beaches, shopping destinations, and scenic coastal locations. We provide AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every group size and travel budget. With experienced drivers, flexible itineraries, transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels ensures a memorable and hassle-free Mumbai sightseeing experience.",

  topPlaces: [
    {
      title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
      description: "One of India's finest museums, Chhatrapati Shivaji Maharaj Vastu Sangrahalaya showcases an exceptional collection of ancient sculptures, paintings, archaeological artifacts, decorative arts, and historical exhibits. Its magnificent Indo-Saracenic architecture makes it a must-visit destination during a Mumbai Darshan tour."
    },
    {
      title: "Girgaon Chowpatty",
      description: "Girgaon Chowpatty is one of Mumbai's most famous beaches, attracting visitors with beautiful sunset views, lively evenings, delicious street food, and cultural celebrations. It is a favorite destination for families, tourists, and photography enthusiasts exploring South Mumbai."
    },
    {
      title: "Nehru Planetarium",
      description: "Nehru Planetarium offers fascinating astronomy shows, interactive science exhibits, and educational programs for visitors of all ages. It is a popular attraction for students, families, and anyone interested in exploring the mysteries of space and the universe."
    },
    {
      title: "Flora Fountain",
      description: "Flora Fountain is a beautifully designed heritage monument located in the heart of South Mumbai. Surrounded by historic colonial buildings, it is an important landmark admired for its Victorian architecture and cultural significance."
    },
    {
      title: "Jehangir Art Gallery",
      description: "Jehangir Art Gallery is one of Mumbai's most prestigious art galleries, featuring exhibitions by renowned artists, contemporary paintings, sculptures, and cultural events. It is a favorite destination for art lovers and creative enthusiasts."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of India's oldest public aquariums, showcasing a wide variety of freshwater and marine species. It offers an enjoyable and educational experience for families, children, and marine life enthusiasts."
    },
    {
      title: "Mahalaxmi Temple",
      description: "Dedicated to Goddess Mahalaxmi, this historic temple is one of Mumbai's most respected religious sites. Thousands of devotees visit throughout the year to seek blessings and experience the temple's peaceful spiritual atmosphere."
    },
    {
      title: "Worli Sea Face",
      description: "Worli Sea Face is a scenic waterfront promenade offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. It is an ideal destination for evening walks, relaxation, and photography."
    },
    {
      title: "Hanging Gardens",
      description: "Located on Malabar Hill, Hanging Gardens is a beautifully landscaped park known for its lush greenery, flower beds, and panoramic views of Marine Drive and the Arabian Sea. It is a popular stop during Mumbai sightseeing tours."
    },
    {
      title: "EsselWorld Waterfront",
      description: "The EsselWorld waterfront area near Gorai offers a refreshing coastal atmosphere with ferry rides, nearby attractions, and family-friendly experiences, making it a pleasant addition to an extended Mumbai sightseeing itinerary."
    }
  ],






"services": [
  {
    "name": "Pune to Mumbai Darshan Package",
    "description": "Book a Pune to Mumbai Darshan Package for a comfortable and well-planned sightseeing experience with professional drivers, clean AC vehicles, and flexible travel schedules. Visit famous attractions across Mumbai while enjoying safe transportation, doorstep pickup, transparent pricing, and convenient one-day or customized travel options. Choose from Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for family trips, corporate outings, weekend travel, and group tours."
  },
  {
    "name": "Pune to Mumbai Tour Package",
    "description": "Choose a Pune to Mumbai Tour Package with comfortable chauffeur-driven cars for sightseeing, family vacations, business leisure trips, and customized travel itineraries. Enjoy reliable service, experienced drivers, and well-maintained vehicles with convenient pickup and drop."
  },
  {
    "name": "Pune to Mumbai Sightseeing Package",
    "description": "Our Pune to Mumbai Sightseeing Package includes comfortable transportation, flexible tour planning, premium vehicles, and professional drivers for visiting Mumbai's popular attractions with family, friends, or corporate groups."
  },
  {
    "name": "Pune to Mumbai One Day Tour Package",
    "description": "Book a Pune to Mumbai One Day Tour Package for a same-day sightseeing trip with clean AC vehicles, experienced chauffeurs, and a hassle-free travel experience covering major destinations in Mumbai."
  },
  {
    "name": "Mumbai Darshan Package from Pune",
    "description": "Enjoy a Mumbai Darshan Package from Pune with affordable pricing, comfortable vehicles, punctual pickup, and customized sightseeing routes suitable for families, tourists, and business travelers."
  },
  {
    "name": "Mumbai City Tour Package from Pune",
    "description": "Book a Mumbai City Tour Package from Pune with Sedan, Ertiga, Innova Crysta, or SUV vehicles for a comfortable city sightseeing experience with professional drivers and flexible schedules."
  },
  {
    "name": "Pune to Mumbai Cab Tour Package",
    "description": "Choose a Pune to Mumbai Cab Tour Package with private chauffeur-driven vehicles offering comfortable travel, convenient pickup, sightseeing stops, and affordable package pricing."
  },
  {
    "name": "Pune to Mumbai Travel Package",
    "description": "Book a Pune to Mumbai Travel Package for family holidays, weekend getaways, business trips, and customized travel with premium vehicles, experienced drivers, and reliable customer support."
  },
  {
    "name": "Pune to Mumbai Tourist Package",
    "description": "Our Pune to Mumbai Tourist Package provides comfortable transportation, sightseeing assistance, clean vehicles, and professional drivers for memorable travel experiences."
  },
  {
    "name": "Mumbai Local Sightseeing Package",
    "description": "Book a Mumbai Local Sightseeing Package with comfortable chauffeur-driven cabs covering popular attractions while ensuring safe, convenient, and enjoyable city travel."
  },
  {
    "name": "Mumbai One Day Tour Package",
    "description": "Choose a Mumbai One Day Tour Package for complete city sightseeing with flexible travel plans, premium vehicles, experienced chauffeurs, and transparent pricing."
  },
  {
    "name": "Pune to Mumbai Holiday Package",
    "description": "Enjoy a Pune to Mumbai Holiday Package with comfortable transportation, premium AC vehicles, customized itineraries, and professional drivers for leisure and vacation travel."
  },
  {
    "name": "Pune to Mumbai Family Tour Package",
    "description": "Book a Pune to Mumbai Family Tour Package with spacious Sedan, Ertiga, Innova Crysta, and SUV vehicles designed for comfortable family sightseeing and weekend trips."
  },
  {
    "name": "Pune to Mumbai Private Tour Package",
    "description": "Hire a Pune to Mumbai Private Tour Package with dedicated chauffeur service, flexible sightseeing schedule, private vehicle, and convenient pickup and drop."
  },
  {
    "name": "Pune to Mumbai Weekend Tour Package",
    "description": "Choose a Pune to Mumbai Weekend Tour Package for short vacations, sightseeing, and comfortable road travel with premium vehicles and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Same Day Tour Package",
    "description": "Book a Pune to Mumbai Same Day Tour Package with early pickup, full-day sightseeing, reliable drivers, and comfortable return travel on the same day."
  },
  {
    "name": "Mumbai Darshan by Cab",
    "description": "Experience Mumbai Darshan by Cab with private chauffeur-driven transportation, clean AC vehicles, sightseeing flexibility, and affordable package options."
  },
  {
    "name": "Mumbai Tour by Cab",
    "description": "Book Mumbai Tour by Cab for comfortable city exploration with experienced drivers, premium vehicles, convenient pickup, and personalized sightseeing routes."
  },
  {
    "name": "Mumbai Sightseeing Tour from Pune",
    "description": "Choose a Mumbai Sightseeing Tour from Pune with reliable cab services, spacious vehicles, and professional chauffeurs for a comfortable one-day or weekend trip."
  },
  {
    "name": "Pune to Mumbai Trip Package",
    "description": "Book a Pune to Mumbai Trip Package with affordable pricing, chauffeur-driven vehicles, and customized travel plans suitable for tourists, families, and business travelers."
  },
  {
    "name": "Pune to Mumbai Darshan Package Price",
    "description": "Check Pune to Mumbai Darshan Package Price with transparent rates for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles without hidden charges."
  },
  {
    "name": "Pune to Mumbai Tour Package Cost",
    "description": "Know the Pune to Mumbai Tour Package Cost with competitive pricing, multiple vehicle options, and flexible sightseeing packages for every budget."
  },
  {
    "name": "Mumbai Darshan Package Fare",
    "description": "View Mumbai Darshan Package Fare with affordable pricing for one-day tours, family sightseeing, corporate outings, and customized travel plans."
  },
  {
    "name": "Pune to Mumbai Sightseeing Package Charges",
    "description": "Check Pune to Mumbai Sightseeing Package Charges with transparent pricing for Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles."
  },
  {
    "name": "Mumbai City Tour Package Price",
    "description": "Explore Mumbai City Tour Package Price with economical travel options, premium chauffeur service, and comfortable vehicles for every group size."
  },
  {
    "name": "Affordable Mumbai Darshan Package",
    "description": "Choose an Affordable Mumbai Darshan Package with budget-friendly pricing, professional drivers, clean vehicles, and comfortable sightseeing services."
  },
  {
    "name": "Cheap Mumbai Tour Package",
    "description": "Book a Cheap Mumbai Tour Package without compromising on comfort, safety, vehicle quality, or reliable chauffeur service."
  },
  {
    "name": "Fixed Price Mumbai Darshan Package",
    "description": "Enjoy a Fixed Price Mumbai Darshan Package with transparent billing, no hidden charges, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Pune to Mumbai Cab Package Cost",
    "description": "Check Pune to Mumbai Cab Package Cost with multiple vehicle choices including Sedan, Ertiga, Innova Crysta, SUVs, and luxury cars for sightseeing and travel."
  },
  {
    "name": "Hinjewadi to Mumbai Darshan Package",
    "description": "Book a Hinjewadi to Mumbai Darshan Package with doorstep pickup, experienced chauffeurs, comfortable AC vehicles, and affordable sightseeing packages."
  },
  {
    "name": "Wakad to Mumbai Darshan Package",
    "description": "Choose a Wakad to Mumbai Darshan Package for reliable pickup, safe travel, premium vehicles, and flexible sightseeing schedules."
  },
  {
    "name": "Baner to Mumbai Darshan Package",
    "description": "Book a Baner to Mumbai Darshan Package with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for family and tourist travel."
  },
  {
    "name": "Kharadi to Mumbai Darshan Package",
    "description": "Hire a Kharadi to Mumbai Darshan Package with comfortable transportation, professional drivers, and customized sightseeing plans."
  },
  {
    "name": "Hadapsar to Mumbai Darshan Package",
    "description": "Book a Hadapsar to Mumbai Darshan Package for convenient travel with clean AC vehicles, experienced chauffeurs, and affordable package pricing."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Darshan Package",
    "description": "Choose a Pimpri Chinchwad to Mumbai Darshan Package with doorstep pickup, premium vehicles, transparent fares, and comfortable sightseeing journeys."
  },
  {
    "name": "Viman Nagar to Mumbai Darshan Package",
    "description": "Book a Viman Nagar to Mumbai Darshan Package with professional drivers, comfortable vehicles, flexible itineraries, and convenient travel."
  },
  {
    "name": "Kothrud to Mumbai Darshan Package",
    "description": "Hire a Kothrud to Mumbai Darshan Package with affordable fares, clean AC vehicles, experienced chauffeurs, and safe sightseeing travel."
  },
  {
    "name": "Aundh to Mumbai Darshan Package",
    "description": "Book an Aundh to Mumbai Darshan Package with premium travel services, comfortable vehicles, and reliable drivers for a memorable sightseeing experience."
  },
  {
    "name": "Shivajinagar to Mumbai Darshan Package",
    "description": "Choose a Shivajinagar to Mumbai Darshan Package with doorstep pickup, professional chauffeurs, clean AC vehicles, transparent pricing, and comfortable sightseeing throughout Mumbai."
  }
],

"tableData": [
  ["Pune to Mumbai Darshan Package", "Pune to Mumbai Tour Package"],
  ["Pune to Mumbai Sightseeing Package", "Pune to Mumbai One Day Tour Package"],
  ["Mumbai Darshan Package from Pune", "Mumbai City Tour Package from Pune"],
  ["Pune to Mumbai Cab Tour Package", "Pune to Mumbai Travel Package"],
  ["Pune to Mumbai Tourist Package", "Mumbai Local Sightseeing Package"],
  ["Mumbai One Day Tour Package", "Pune to Mumbai Holiday Package"],
  ["Pune to Mumbai Family Tour Package", "Pune to Mumbai Private Tour Package"],
  ["Pune to Mumbai Weekend Tour Package", "Pune to Mumbai Same Day Tour Package"],
  ["Mumbai Darshan by Cab", "Mumbai Tour by Cab"],
  ["Mumbai Sightseeing Tour from Pune", "Pune to Mumbai Trip Package"],
  ["Pune to Mumbai Darshan Package Price", "Pune to Mumbai Tour Package Cost"],
  ["Mumbai Darshan Package Fare", "Pune to Mumbai Sightseeing Package Charges"],
  ["Mumbai City Tour Package Price", "Affordable Mumbai Darshan Package"],
  ["Cheap Mumbai Tour Package", "Fixed Price Mumbai Darshan Package"],
  ["Pune to Mumbai Cab Package Cost", "Hinjewadi to Mumbai Darshan Package"],
  ["Wakad to Mumbai Darshan Package", "Baner to Mumbai Darshan Package"],
  ["Kharadi to Mumbai Darshan Package", "Hadapsar to Mumbai Darshan Package"],
  ["Pimpri Chinchwad to Mumbai Darshan Package", "Viman Nagar to Mumbai Darshan Package"],
  ["Kothrud to Mumbai Darshan Package", "Aundh to Mumbai Darshan Package"],
  ["Shivajinagar to Mumbai Darshan Package", ""]
],





whychoose: [
  {
    WhyChooseheading: "Complete Pune to Mumbai Darshan Package",
    WhyChoosedescription: "Trustline Travels offers well-planned Pune to Mumbai Darshan packages covering Mumbai's famous attractions with comfortable and reliable cab services."
  },
  {
    WhyChooseheading: "Flexible Sightseeing Schedule",
    WhyChoosedescription: "Customize your Mumbai Darshan itinerary by choosing the tourist places, temples, beaches, and landmarks you wish to explore."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Group Size",
    WhyChoosedescription: "Book Sedan, Ertiga, Innova, Innova Crysta, SUVs, or Tempo Travellers for couples, families, friends, and corporate groups."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Tours",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Mumbai sightseeing routes, ensuring efficient travel and maximum sightseeing time."
  },
  {
    WhyChooseheading: "Budget-Friendly Tour Packages",
    WhyChoosedescription: "Enjoy affordable Mumbai Darshan packages with transparent pricing, detailed quotations, and no hidden costs."
  },
  {
    WhyChooseheading: "One-Day & Customized Tour Options",
    WhyChoosedescription: "Choose from one-day Mumbai sightseeing packages or personalized tour plans based on your travel schedule."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Pune",
    WhyChoosedescription: "We provide pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations across Pune."
  },
  {
    WhyChooseheading: "Quick Booking & Dedicated Assistance",
    WhyChoosedescription: "Receive instant quotations, fast booking confirmation, and responsive customer support for a hassle-free Mumbai Darshan experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mumbai Darshan packages?",
    answer: "Yes, Trustline Travels offers complete Pune to Mumbai Darshan packages for families, couples, groups, and corporate travelers."
  },
  {
    question: "Which places are included in the Mumbai Darshan package?",
    answer: "Popular attractions such as Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali Dargah, Juhu Beach, Bandra Bandstand, Hanging Garden, and other famous landmarks can be included."
  },
  {
    question: "Can I customize my Mumbai Darshan package?",
    answer: "Yes, you can customize your sightseeing itinerary based on your preferred destinations and available travel time."
  },
  {
    question: "Which vehicles are available for Mumbai sightseeing?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable Mumbai tours."
  },
  {
    question: "Is a one-day Mumbai Darshan package available?",
    answer: "Yes, we offer one-day Mumbai Darshan packages with flexible pickup and return schedules."
  },
  {
    question: "Are toll, parking, and entry charges included?",
    answer: "Toll charges, parking fees, entry tickets, and applicable taxes are generally charged separately unless specifically included in your package."
  },
  {
    question: "Do you provide pickup from all areas of Pune?",
    answer: "Yes, we offer doorstep pickup from homes, hotels, offices, Pune Airport, Pune Railway Station, and all major locations in Pune."
  },
  {
    question: "Can families and groups book Mumbai Darshan packages?",
    answer: "Yes, our sightseeing packages are ideal for families, friends, tourists, senior citizens, and corporate groups."
  },
  {
    question: "Should I book the Mumbai Darshan package in advance?",
    answer: "Yes, advance booking is recommended to ensure your preferred vehicle and sightseeing schedule."
  },
  {
    question: "How can I book a Pune to Mumbai Darshan package with Trustline Travels?",
    answer: "Simply share your travel date, pickup location, passenger count, preferred vehicle, and sightseeing requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Naik",
    feedback: "Trustline Travels organized our Pune to Mumbai Darshan package perfectly. We visited all the famous attractions comfortably, and the driver guided us efficiently throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepali Joshi",
    feedback: "Our Mumbai sightseeing package was excellent from beginning to end. The vehicle was comfortable, the itinerary was flexible, and Trustline Travels made the entire experience enjoyable for our family.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Darshan Package",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-darshan-package.webp",
  "description": "Book Pune to Mumbai Darshan Package with Trustline Travels for comfortable sightseeing and tour experiences. Enjoy Mumbai sightseeing, one day tour packages, and private cab services from Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5824"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-darshan-package"
  }
};


  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Darshan Package | One Day Tour Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Darshan Package with Trustline Travels for Mumbai sightseeing and one day tour travel. Get comfortable private cabs from Pune with experienced drivers and multiple car options available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Darshan Package, Pune to Mumbai Tour Package, Pune to Mumbai Sightseeing Package, Pune to Mumbai One Day Tour Package, Mumbai Darshan Package from Pune, Pune Mumbai sightseeing tour, Pune to Mumbai tour cab, Mumbai one day tour from Pune, Pune Mumbai travel package, Pune to Mumbai sightseeing taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaidarshanpackage;